module.exports = __webpack_public_path__ + "img/f3-card-2.aa044d44.png";